import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import PopItem from '@/components/item/ItemPop.vue'
import { comma } from '@/components/mixins/comma.js';
export const myItemBuy = {   
    mixins:[ comma ],
    data(){
        return{
            itemlists:'',
            itemState:['사용완료','사용가능','승인대기','환불신청','환불완료','이용중'],
            ckItemUse:false,
            currentItemId:0,
            selcomponent:'',
            poptitle:''
        }
    },
    components:{
        DisplayTime,
        Paginate,
        PopItem
    },
    mounted()
    {
        this.getBuyItems();
    },
    computed:{
        itembuylists(){
            return this.$store.state.item.itemBuy;
        }
    },
    methods:{
        confirm(){
            this.ckItemUse = false;
        },
        popUse(current){
            this.poptitle ='아이템 사용하기';
            this.selcomponent = 'itemUse';
            this.currentItemId=current;
            this.ckItemUse = true;

        },
        refund(current){
            this.poptitle ='환불신청';
            this.selcomponent = 'refund';
            this.currentItemId=current;
            this.ckItemUse = true;

        },
        async getBuyItems(pagenumber){
           const formData = {
                user_id:this.$store.getters.currentUser.id,  page:pagenumber?pagenumber:1
            }
            try {
                const response = await this.$store.dispatch("item/getBuyItems", formData)
                this.itemlists = response;
            }catch(error){
                console.log(error);
            }
        },
        async itemUse(idx,iCount){
            const formData = {
                user_id:this.$store.getters.currentUser.id,  itemBuyId:idx, count:iCount
            }
            try {
                const response = await this.$store.dispatch("item/itemUse", formData)
                this.getBuyItems();
                console.log(response);
                if(response.itemUse)
                {
                    this.$store.commit('updateUserPoint',response.user);
                }
                this.$flashMessage.show({
                    type: response.itemBuy===false?"error":"info",
                    title: response.message,
                    message: response.message,
                });
            }catch(error){
                console.log(error);
            }
        },
    }
}